import { Alert, Snackbar } from '@mui/material';
import zIndex from '@mui/material/styles/zIndex';
import React from 'react';

const Toast: React.FC<{
  open: boolean;
  onClose: () => void;
  variant: 'success' | 'error';
  content: string;
  vertical?: 'top' | 'bottom';
  horizontal?: 'center' | 'left' | 'right';
}> = ({ open, onClose, variant, content, vertical = 'top', horizontal = 'center' }) => (
  <Snackbar open={open} anchorOrigin={{ vertical, horizontal }} autoHideDuration={1000} onClose={onClose} sx={{ zIndex: 999999 }}>
    <Alert onClose={onClose} severity={variant} variant="filled">
      {content}
    </Alert>
  </Snackbar>
);

export default Toast;
